var map = {
	"./Senza-titolo-1": 191,
	"./Senza-titolo-1.jpg": 191,
	"./demo/adv_300x250": 192,
	"./demo/adv_300x250.jpg": 192,
	"./demo/adv_960x90": 193,
	"./demo/adv_960x90.jpg": 193,
	"./demo/boss": 194,
	"./demo/boss.jpg": 194,
	"./demo/content_10": 195,
	"./demo/content_10.jpg": 195,
	"./demo/content_2": 196,
	"./demo/content_2.jpg": 196,
	"./demo/content_3": 197,
	"./demo/content_3.jpg": 197,
	"./demo/content_4": 198,
	"./demo/content_4.jpg": 198,
	"./demo/content_5": 199,
	"./demo/content_5.jpg": 199,
	"./demo/content_6": 200,
	"./demo/content_6.jpg": 200,
	"./demo/content_7": 201,
	"./demo/content_7.jpg": 201,
	"./demo/content_8": 202,
	"./demo/content_8.jpg": 202,
	"./demo/content_9": 203,
	"./demo/content_9.jpg": 203,
	"./demo/main": 204,
	"./demo/main.jpg": 204,
	"./demo/main2": 205,
	"./demo/main2.jpg": 205,
	"./demo/main3": 206,
	"./demo/main3.jpg": 206,
	"./demo/main4": 207,
	"./demo/main4.jpg": 207,
	"./demo/menu": 208,
	"./demo/menu.jpg": 208,
	"./demo/top": 209,
	"./demo/top.jpg": 209,
	"./demo/top2": 210,
	"./demo/top2.jpg": 210,
	"./demo/top3": 211,
	"./demo/top3.jpg": 211,
	"./demo/wall1": 212,
	"./demo/wall1.jpg": 212,
	"./demo/wall1_m": 213,
	"./demo/wall1_m.jpg": 213,
	"./demo/wall2": 214,
	"./demo/wall2.jpg": 214,
	"./demo/wall2_m": 215,
	"./demo/wall2_m.jpg": 215,
	"./insta-bg": 216,
	"./insta-bg.gif": 216,
	"./logo": 217,
	"./logo.png": 217,
	"./shop": 218,
	"./shop.jpg": 218,
	"./travel": 219,
	"./travel.jpg": 219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 328;